/**
 * Triggers a browser file download of CSV content as a .csv file.
 * @param filename The name of the file to save (e.g. 'perf-traces.csv')
 * @param csvContent The CSV text string to download
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "downloadCSV", {
    enumerable: true,
    get: function() {
        return downloadCSV;
    }
});
function downloadCSV(filename, csvContent) {
    const blob = new Blob([
        csvContent
    ], {
        type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
